// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdatePurchaseOrderStatusMutation(
    $input: UpdatePurchaseOrderStatusInput!
  ) {
    updatePurchaseOrderStatus(input: $input) {
      purchaseOrder {
        id
        poNumber
        status
        receivedAt
        approvedBy {
          id
          firstName
          lastName
        }
        approvedAt
        updatedAt
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
